import router from './router';
import NProgress from 'nprogress';
import 'nprogress/nprogress.css';
import Store from './store/index.js';

router.beforeEach(async (to, from, next) => {
  // 开始显示进度条
  NProgress.start();
  Store.state.fromPage=from.path;
  next();
  NProgress.done();
});

router.afterEach(() => {
  NProgress.done();
});